import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { colors, radii, spacing } from '../../theme';
import Icon from '../ui/Icon';
import Text from '../ui/Text';

/**
 * "Not here yet" - the soft version, for a customer in a city we serve but
 * at a spot ops has not opened.
 *
 * Soft on purpose. The city-wide "coming to your city soon" message replaces
 * Home, because nothing in that city can be booked. Here the city is live and
 * the next street may well be served, so the catalogue stays visible (greyed
 * where it cannot be booked) and this sits above it, pointing at the one
 * control that can change the answer: the address.
 */
function AreaNotServedNotice({
  onChangeAddress,
}: {
  onChangeAddress: () => void;
}) {
  return (
    <View style={styles.card} accessibilityRole="summary">
      <Icon name="pin" size={18} color={colors.inkMuted} />
      <View style={styles.copy}>
        <Text variant="labelBold">We're not in your area yet</Text>
        <Text variant="bodySm" style={styles.body}>
          We don't serve this location yet. We're expanding - we'll let you
          know as soon as we're available here.
        </Text>
        <Pressable
          onPress={onChangeAddress}
          accessibilityRole="button"
          hitSlop={8}
          style={styles.action}
        >
          <Text variant="label" color={colors.ink}>
            Change address
          </Text>
        </Pressable>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: spacing.sm,
    marginTop: spacing.md,
    padding: spacing.md,
    borderRadius: radii.md,
    backgroundColor: colors.surfaceMuted,
  },
  copy: {
    flex: 1,
  },
  body: {
    marginTop: spacing.xs,
  },
  action: {
    alignSelf: 'flex-start',
    marginTop: spacing.sm,
  },
});

export default React.memo(AreaNotServedNotice);
